import _ from 'lodash';
import { log } from '@swiper/core';
import config from '~/config';
import { Service } from './Service';

export class StationsService extends Service {

  get name() { return 'stations'; }

  constructor( opts={} ) {
    super( {} );
    this.stations = config.get( 'stations' );
  }

  async find( params ) {
    return _.filter( this.stations, params.query );
  }

  async get( id, params ) {
    const found = _.find( this.stations, { id } );
    if ( found ) return found;
    const err = this.error( 'NotFound', `Station with id ${id} not found` );
    return Promise.reject( err );
  }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
